import { Box, Button } from '@warp-ds/react';
import { useState } from 'react';
import { FinnLogo } from 'shared/icons/FinnLogo';
import { PublishFormButton } from '@/components/button/PublishFormButton';
import { BenefitExpandable } from '@/components/shared/BenefitExpandable';
import { useUnleash } from '@/hooks/unleash';
import { trackCreateOrRepublishAdButton } from '@/utils/tracking';

type Props = {
    csrfMicroServiceToken: string;
    variant: string;
    itemId?: string;
};

export const FinnBoxWithDropdown = ({ csrfMicroServiceToken }: Props) => {
    const unleash = useUnleash();
    const [loading, setLoading] = useState(false);
    const actionPath = '/innfinn/adselection/ad/';
    const atlasUrl = '/realestate/private/item/create?adType=realestate-letting';

    return (
        <Box bordered className="flex flex-col h-full !p-0">
            <div className="flex flex-col flex-1 px-16 pt-16 md:px-24 md:pt-24">
                <div className="mb-4" role="img" aria-label="FINN">
                    <FinnLogo size="qasa" aria-hidden="true" />
                </div>
                <div className="flex flex-col mt-16">
                    <div className="flex-1">
                        <div className="md:mb-16">
                            <h2 className="t3 mb-8 flex items-center">Annonse på FINN</h2>
                            <p className="mb-16 mt-16 md:mt-0 min-h-[48px] md:min-h-0">Lei ut på FINN, akkurat som før</p>
                            {unleash.realestateAtlasAppLinksRealestateLetting ? (
                                <Button
                                    loading={loading}
                                    fullWidth
                                    primary={!loading}
                                    onClick={() => {
                                        setLoading(true);
                                        trackCreateOrRepublishAdButton('finn', null, true);
                                        window.location.href = atlasUrl;
                                        setTimeout(() => {
                                            setLoading(false);
                                        }, 10000);
                                    }}
                                    type="button">
                                    Ny annonse på FINN
                                </Button>
                            ) : (
                                <PublishFormButton actionPath={actionPath} csrfMicroServiceToken={csrfMicroServiceToken} />
                            )}
                            <div className="mb-8 mt-24">
                                <div className="mb-8">Dette får du med FINN:</div>
                                <BenefitExpandable
                                    type="finn"
                                    title="Annonse på FINN, 15 - 60 dager"
                                    items={[
                                        'Din annonse vil være synlig på FINN i 15-60 dager avhengig av hvilken annonsepakken du velger.',
                                    ]}
                                />
                                <BenefitExpandable
                                    type="finn"
                                    title="Mulighet for økt synlighet"
                                    items={[
                                        'Finn den rette leietaker raskere med ekstra synlighet på resultatlisten eller få med nyttig informasjon om ditt nabolag (distanser til buss, skoler m.m). Hvilke tjenester som er inkludert avhenger av hvilken annonsepakke du velger.',
                                    ]}
                                />
                                <BenefitExpandable
                                    type="finn"
                                    title="Varslinger på mail til de som har lagret søk"
                                    items={[
                                        'FINN sørger for at din annonse blir sett av flest mulig. Varslingen blir sendt enten som en push-melding eller på epost (eller begge deler) til relevante leietakere. Gjelder alle annonsepakker.',
                                    ]}
                                />
                                <BenefitExpandable
                                    type="finn"
                                    title="Digital husleiekontrakt"
                                    items={[
                                        'Gratis leiekontrakt som forhåndsutfylles med opplysninger fra FINN-annonsen. Kontrakten er godkjent av forbrukerrådet og signeres enkelt digitalt. Gjelder alle annonsepakker.',
                                    ]}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="text-16 mt-8 md:mt-16 p-16 rounded-8 min-h-[96px] md:min-h-0" style={{ backgroundColor: '#F6F8FB' }}>
                    <div>Annonse leilighet og hus:</div>
                    <div> 635 kr - 1555 kr</div>
                    <div className="mt-24">Annonse hybel og rom i bofellesskap:</div>
                    <div> 175 kr - 636 kr</div>
                    <div className="mt-24">Annonseprisen avhenger av utleiepris, boligtype, størrelse og annonsepakke</div>
                </div>
            </div>
            <div className="text-center py-8 mt-24 flex justify-center gap-8 rounded-b-8 min-h-[48]" style={{ backgroundColor: '#F0F0EB' }}>
                <div className="text-s mt-8">En del av</div>
                <img src="/realestate/lettings/icons/qasa/vend.svg" height="24px" width="61px" alt={'Vend logo'} />
            </div>
        </Box>
    );
};
